import { actionGenerator, IReduxAction } from '../../utils/actions';

export const SELECT_PACKAGE = 'PUBLISH_TERMS :: SELECT_PACKAGE';

export type TSelectPackageAction = IReduxAction<typeof SELECT_PACKAGE, string>;

export const selectPackage = actionGenerator<typeof SELECT_PACKAGE, string>(SELECT_PACKAGE);
